export const isStatisticsEnabled = (isProduction: boolean) => {
  if (!isProduction) {
    return true;
  }

  return typeof window !== 'undefined' && (window as any).Cookiebot?.consent?.statistics === true;
};

export const initCookiebot = (onEnableStatisticsToolsChanged: (enableStatisticsTools: boolean) => void, isProduction: boolean) => {
  if (!isProduction || typeof window === 'undefined') {
    return;
  }

  // Add cookie bot event listener
  const callbackCookiebotOnConsentReady = (e: EventInit) => {
    const enableStatisticsTools = (e as any).target?.Cookiebot.consent.statistics as boolean;
    onEnableStatisticsToolsChanged(enableStatisticsTools);
  };
  window.addEventListener('CookiebotOnConsentReady', callbackCookiebotOnConsentReady, false);
};
